(function () {
    'use strict';

    angular
        .module('app.eventDisplay')
        .controller('PromotionalImagesListController', PromotionalImagesListController);

    PromotionalImagesListController.$inject = ['common', 'dataservice', 'config', 'carousel.dialog'];
    /* @ngInject */
    function PromotionalImagesListController(common, dataservice, config, carouselDialog) {
        var vm = this;
        vm.title = "Promotional Images"
        vm.displayedItems = [];
        vm.items = [];
        vm.refresh = refresh;
        vm.showImage = showImage;
        vm.isLicenseValid = false;
        vm.isLoading = true;


        activate();

        function activate() {
            var promises = [getItems(), getLicenseInfo()];
            return common.$q.all(promises).then(function (data) {
                common.logger.info('Activated ' + vm.title + ' View');
                vm.isLoading = false;
            }, function (error) { });
        }

        function getLicenseInfo() {
            return dataservice.getItems('api/Tenants/GetLicenseInfo').then(function (response) {
                vm.licenseInfo = response.data;
                vm.isLicenseValid = (
                    vm.licenseInfo.NumberOfDisplaysLicensed >= vm.licenseInfo.NumberOfDisplaysInUse
                    || vm.licenseInfo.NumberOfPaymentTemplatesLicensed >= vm.licenseInfo.NumberOfPaymentTemplatesInUse
                    
                );
                return vm.licenseInfo;
            }, function (error) { });
        }


        function getItems() {
            return dataservice.getItems('api/PromotionalImages').then(function (response) {
                vm.items = response.data;
                vm.displayedItems = [].concat(vm.items);
                return vm.items;
            }, function (error) { });
        }

        function refresh() {
            getItems();
        }

        function showImage(item) {
            return carouselDialog.display(item);

        }
    }
})();
